import { useSettings, type Quality } from '../stores/settings-store';

function Slider({ label, value, onChange }: { label: string; value: number; onChange: (v: number) => void }) {
  const id = `s-${label.replace(/\s/g, '')}`;
  return (
    <div className="field" style={{ marginBottom: 10 }}>
      <label htmlFor={id}>
        {label} <span className="gold">{Math.round(value * 100)}%</span>
      </label>
      <input
        id={id}
        type="range"
        min={0}
        max={1}
        step={0.05}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}

/** Audio, graphics and interface settings (persisted in localStorage). */
export function SettingsPanel() {
  const s = useSettings();
  return (
    <div>
      <Slider label="Master volume" value={s.masterVolume} onChange={(v) => s.update({ masterVolume: v })} />
      <Slider label="Music" value={s.musicVolume} onChange={(v) => s.update({ musicVolume: v })} />
      <Slider label="Effects" value={s.sfxVolume} onChange={(v) => s.update({ sfxVolume: v })} />
      <label className="row" style={{ marginBottom: 12, cursor: 'pointer' }}>
        <input type="checkbox" checked={s.muted} onChange={(e) => s.update({ muted: e.target.checked })} />{' '}
        Mute all audio
      </label>
      <div className="field">
        <label>Graphics quality</label>
        <div className="chip-row" role="radiogroup" aria-label="Graphics quality">
          {(['auto', 'low', 'medium', 'high'] as Quality[]).map((q) => (
            <button
              key={q}
              type="button"
              className="chip"
              role="radio"
              aria-checked={s.quality === q}
              aria-pressed={s.quality === q}
              onClick={() => s.update({ quality: q })}
            >
              {q[0]?.toUpperCase() + q.slice(1)}
            </button>
          ))}
        </div>
      </div>
      <label className="row" style={{ marginBottom: 8, cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={s.showFps}
          onChange={(e) => s.update({ showFps: e.target.checked })}
        />{' '}
        Show FPS and network stats
      </label>
      <label className="row" style={{ cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={s.showDamageNumbers}
          onChange={(e) => s.update({ showDamageNumbers: e.target.checked })}
        />{' '}
        Floating damage numbers
      </label>
    </div>
  );
}
